var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold / Arrows / Alt Arrow Down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3392 14.5162L17.2331 8.43826C17.6009 8.05901 17.3779 7.33398 16.8936 7.33398H5.10579C4.62141 7.33398 4.39848 8.05901 4.76625 8.43826L10.6601 14.5162C10.8555 14.7177 11.1438 14.7177 11.3392 14.5162Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.ce32f089464a1bc3daba6d91b42b3567.svg";
export { ForwardRef as ReactComponent };